// extracted by css-extract-rspack-plugin
export default {"breadcrumb":"src-pages-girder-styles-module__breadcrumb-X2y1Sh","pageTitle":"src-pages-girder-styles-module__pageTitle-UPmH8v","cardList":"src-pages-girder-styles-module__cardList-YSU9Ut","folder":"src-pages-girder-styles-module__folder-UchcxZ","collectionCard":"src-pages-girder-styles-module__collectionCard-NMCYJp","itemgrid":"src-pages-girder-styles-module__itemgrid-krWO2N","emptyHint":"src-pages-girder-styles-module__emptyHint-lTsZs5"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"breadcrumb\":\"src-pages-girder-styles-module__breadcrumb-X2y1Sh\",\"pageTitle\":\"src-pages-girder-styles-module__pageTitle-UPmH8v\",\"cardList\":\"src-pages-girder-styles-module__cardList-YSU9Ut\",\"folder\":\"src-pages-girder-styles-module__folder-UchcxZ\",\"collectionCard\":\"src-pages-girder-styles-module__collectionCard-NMCYJp\",\"itemgrid\":\"src-pages-girder-styles-module__itemgrid-krWO2N\",\"emptyHint\":\"src-pages-girder-styles-module__emptyHint-lTsZs5\"}";
        // 1793732399082
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  